document.addEventListener("DOMContentLoaded", function () {
    const targetBundleProductNode = document.body;

    const observer = new MutationObserver(function (mutationsList, observer) {
        if (document.querySelector(".ppcse-img-lt .ppcse-img-lt-li")) {
            observer.disconnect();

            let clonedPpcse = $(".ppcse-img-lt").clone();
            $("h3.ppcse-title").eq(0).after($('<div class="ppcsc__container__wrap"></div>').append(clonedPpcse));

            let currentIndex = 0;
            $(".ppcsc__container__wrap .ppcse-img-lt .ppcse-img-lt-li").each(function () {
                let currentElement = $(this)
                let productInfo = $(".ppcse-list-lt li").eq(currentIndex);
                let titleWrap = productInfo.find(".ppcse-list-lt-label-cont");
                let spanWrap = titleWrap.find('span');
                let productTitle = '';
                let productPriceHtml = titleWrap.find('b').html();

                if (spanWrap.length > 3) {
                    productTitle = spanWrap.eq(1).html();
                } else {
                    productTitle = spanWrap.eq(0).html();
                }

                currentElement.append(`<div class="product__details__container">
                                            <div class="title__container">
                                            <h2>${productTitle}</h2>
                                            </div>
                                            <div class="price__container">${productPriceHtml}</div>
                                            <button type="button" data-pindex="${currentIndex}">Add To Cart</button>
                                        </div>`)

                currentIndex++;
            });
        }
    });

    observer.observe(targetBundleProductNode, { childList: true, subtree: true });
});


$(document).ready(function () {
    $(document).on('click', '.product__details__container button', function () {
        let currentListIndex = $(this).attr('data-pindex');
        currentListIndex = parseInt(currentListIndex);
        let allChkBox = $(".ppcse-list-lt").find("input[type='checkbox']");
        //let selectedChkBox = $(".ppcse-list-lt li").eq(currentListIndex).find("input[type='checkbox']");

        let index = 0;
        allChkBox.each(function () {            
            if (currentListIndex == index) {
                !$(this).prop("checked") && $(this).trigger("click");            
            }
            else {  
                $(this).prop("checked") && $(this).prop("disabled", false) &&  $(this).trigger("click");
            }
            index++;
        })

        isCartNotEmpty((notEmpty) => {
            if (notEmpty && !getCartExpiry()) {
                setCartExpiry();
            }
            startGlobalCartTimer(true);
        });

        $(".ppcse-tot-container .ppcse-tot-btn-div").click()        
    });
})
